import { computed, signal } from "@preact/signals-react"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { DATE_PERIODS, PREVIOUS_PERIODS } from "@constants"

const __currentTime = new Date()
__currentTime.setHours(10, 0)

//Signals
export const currentPeriod = signal(DATE_PERIODS.LAST_7_DAYS)
export const dateRange = signal([getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })])
export const singleDate = signal(getPreviousDate({ days: 1 }))
export const startHour = signal(__currentTime)
export const endHour = signal(__currentTime)
export const rentalDates = signal([])
export const rentalLength = signal([])
export const lengthRental = signal(null)
export const datePreset = signal('custom')
export const bookingRange = signal([getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })])
export const analyzerDate = signal(null)
export const bookingWeeks = signal([])
// Computed
export const startDate = computed(() => formatDate(dateRange.value[0], { format: FORMAT_DATE_BACK }))
export const endDate = computed(() => formatDate(dateRange.value[1], { format: FORMAT_DATE_BACK }))
export const prevStartDate = computed(() => formatDate((PREVIOUS_PERIODS[currentPeriod.value] || [null, null])[0], {
	format: FORMAT_DATE_BACK
}))
export const prevEndDate = computed(() => formatDate((PREVIOUS_PERIODS[currentPeriod.value] || [null, null])[1], {
	format: FORMAT_DATE_BACK
}))

export const singleDateFormated = computed(() => formatDate(singleDate.value, { format: FORMAT_DATE_BACK }))